var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("text-header", { attrs: { id: "supplementary-agreements" } }, [
        _vm._v("Дополнительные соглашения"),
      ]),
      _vm.purchase.supplementary_agreements.length > 0
        ? _c(
            "div",
            { staticClass: "accordion", attrs: { role: "tablist" } },
            _vm._l(
              _vm.purchase.supplementary_agreements,
              function (supplementaryAgreement, key) {
                return _c(
                  _vm.supplementaryAgreementComponent(supplementaryAgreement),
                  {
                    key: `supplementary-agreement-${key}`,
                    tag: "component",
                    attrs: {
                      purchase: _vm.purchase,
                      title: `${supplementaryAgreement.fl44_contract_supplementary_agreement_type.title} №${supplementaryAgreement.number}`,
                      "supplementary-agreement": supplementaryAgreement,
                      visible:
                        _vm.purchase.last_supplementary_agreement_id ===
                        supplementaryAgreement.id,
                    },
                    on: { refresh: _vm.done },
                  }
                )
              }
            ),
            1
          )
        : _vm._e(),
      _vm.isPurchaseCreator() && _vm.purchase.status.id === "contract:active"
        ? [
            !_vm.isCreate
              ? _c(
                  "b-dropdown",
                  {
                    staticClass: "mt-1",
                    attrs: {
                      text: "Добавить дополнительное соглашение",
                      variant: "custom-green",
                    },
                  },
                  _vm._l(
                    _vm.$globalDictionaries.fl44SupplementaryAgreementTypes,
                    function (type) {
                      return _c(
                        "b-dropdown-item",
                        {
                          key: type.id,
                          staticClass: "fs-14",
                          on: {
                            click: function ($event) {
                              return _vm.createClicked(type.id)
                            },
                          },
                        },
                        [_vm._v(_vm._s(type.title))]
                      )
                    }
                  ),
                  1
                )
              : _c(_vm.createComponent, {
                  tag: "component",
                  attrs: {
                    "purchase-id": _vm.purchase.id,
                    purchase: _vm.purchase,
                  },
                  on: {
                    cancel: function ($event) {
                      _vm.isCreate = false
                    },
                    done: _vm.done,
                  },
                }),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }